// extracted by mini-css-extract-plugin
export default {"heading":"pG","container":"qG","product_section_row":"rG","carousel":"sG","carouselwide":"tG","carouselwrapper":"uG","blockwrapper":"vG","product_carousel_row":"wG","headingnarrow":"xG","title":"yG"};
    if(module.hot) {
      // 1714442369974
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  